import { Vector2 } from "../../../maths/Vector2";
import { NotImplementedError } from "../../../utils/Error";
export class SetRendertarget2DCMD {
    constructor() {
        this.size = new Vector2;
    }
    get invertY() {
        return this._invertY;
    }
    set invertY(value) {
        this._invertY = value;
    }
    get clearColorValue() {
        return this._clearColorValue;
    }
    set clearColorValue(value) {
        this._clearColorValue = value;
    }
    get rt() {
        return this._rt;
    }
    set rt(value) {
        this._rt = value;
    }
    get clearColor() {
        return this._clearColor;
    }
    set clearColor(value) {
        this._clearColor = value;
    }
    apply(context) {
        throw new NotImplementedError();
    }
}
export class Draw2DElementCMD {
    setRenderelements(value) {
        throw new NotImplementedError();
    }
    apply(context) {
        throw new NotImplementedError();
    }
}
export class Blit2DQuadCMD {
    get element() {
        return this._element;
    }
    set element(value) {
        this._element = value;
    }
    get dest() {
        return this._dest;
    }
    set dest(value) {
        this._dest = value;
    }
    get source() {
        return this._source;
    }
    set source(value) {
        this._source = value;
    }
    get offsetScale() {
        return this._offsetScale;
    }
    set offsetScale(value) {
        this._offsetScale = value;
    }
    apply(context) {
        throw new NotImplementedError();
    }
}
